import { Tooltip, withTheme } from "@material-ui/core";

const MapPopupTooltip = ({ title, theme, children }) => (
  <Tooltip
    classes={{
      popper: 'popper',
      tooltip: `tooltip-${theme.themeName}`
    }}
    title={title}>
    {children}
  </Tooltip>
);

export default withTheme()(MapPopupTooltip);